import { defineMessages } from 'react-intl'

export default defineMessages({
  help: {
    id: 'containers.AdminSupplierOnboarding.help',
    defaultMessage: '',
  },
})
